export const EDITING_TIMEOUT_MINUTES = 5;

const EDITING_TIMEOUT_SECONDS = EDITING_TIMEOUT_MINUTES * 60;

export const isEditingTimedOut = (event, now) => {
  if (!event || !event.updating || event.updating_started_at == null) {
    return false;
  }
  const nowSeconds = Math.floor(now / 1000);
  return nowSeconds - event.updating_started_at >= EDITING_TIMEOUT_SECONDS;
};
